import React from 'react';
import { Helmet } from 'react-helmet';
import Header from '../components/Header';
import OurStories from '../components/blog/OurStories';
import Fostering from '../components/blog/Fostering';
import AllBlogs from '../components/blog/AllBlogs';
import GetStarted from '../components/GetStarted';
import Footer from '../components/Footer';

const Blog = () => {
  return (
    <>
      <Helmet>
        <title>Explore the Latest Lipaworld Blog | Lipaworld Corp</title>
        <meta
          name="description"
          content="Explore expert insights, financial guides, and the latest trends in global money transfers, online payments, and marketplace security on our Lipaworld blog."
        />
        <link rel="canonical" href="https://www.lipaworld.com/blog" />
      </Helmet>
      <div className="min-h-screen">
        <div className="container mx-auto px-4">
          <Header />
          <main>
            <OurStories />
            <Fostering />
            <AllBlogs />
            <GetStarted />
            <Footer />
          </main>
        </div>
      </div>
    </>
  );
};

export default Blog;
